var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckupGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25971_1638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.32812 4.26522C5.32812 3.38254 6.05934 2.66699 6.96133 2.66699C12.9836 2.66699 19.0059 2.66704 25.0282 2.667C25.9302 2.66699 26.6615 3.38255 26.6615 4.26523V29.0688C26.6615 29.9514 25.9302 30.667 25.0283 30.667C19.0059 30.667 12.9836 30.667 6.96133 30.667C6.05934 30.667 5.32812 29.9514 5.32812 29.0688V4.26522Z",
    fill: "#EDEDF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66406 1.59822C2.66406 0.715548 3.39527 -2.35338e-07 4.29727 0C10.3196 1.57127e-06 16.3419 4.58074e-05 22.3642 7.50112e-06C23.2662 1.76374e-06 23.9974 0.715556 23.9974 1.59824V26.4018C23.9974 27.2845 23.2662 28 22.3642 28C16.3419 28 10.3196 28 4.29727 28C3.39527 28 2.66406 27.2844 2.66406 26.4018V1.59822Z",
    fill: "#D2D2D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.2969,
    y: 20.082,
    width: 5.33333,
    height: 2.66667,
    transform: "rotate(45 19.2969 20.082)",
    fill: "#FAFAFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.4375,
    y: 22.2764,
    width: 10.6775,
    height: 4,
    rx: 2,
    transform: "rotate(45 22.4375 22.2764)",
    fill: "#91919C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 14.667,
    width: 10.6667,
    height: 1.33333,
    rx: 0.666667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.66406,
    y: 4,
    width: 6.66667,
    height: 1.33333,
    rx: 0.666667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 17.333,
    width: 9.33333,
    height: 1.33333,
    rx: 0.666666,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.6641,
    cy: 16,
    r: 7,
    stroke: "#91919C",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25971_1638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckupGray);
export default __webpack_public_path__ + "static/media/icon-checkup-gray.815069a1643a3568947644643f7e2518.svg";
export { ForwardRef as ReactComponent };